import Swiper from 'swiper';
import { A11y, Keyboard } from 'swiper/modules';

// "Weitere Beitraege" am Fuss der Insights-Detailseite: auf Mobil ein wischbarer
// Swiper mit Peek auf die naechste Kachel, ab Tablet wieder das normale
// CSS-Grid.
//
// Die Swiper-Struktur (.swiper / .swiper-wrapper / .swiper-slide) wird bewusst
// erst per JS aufgebaut und oberhalb des Breakpoints wieder abgeraeumt, statt
// sie fest ins Markup zu schreiben. Grund: swiper.css setzt auf .swiper-wrapper
// hart `display: flex` und auf .swiper-slide eine feste Breite - beides muesste
// man fuer die Grid-Ansicht sonst dauerhaft ueberschreiben. So bleibt das
// Desktop-Grid voellig unberuehrt.
//
// Die Karten selbst werden nur umgehaengt, nicht neu erzeugt - sie sind reine
// Links, es gehen also keine Zustaende oder Listener verloren.

const MOBILE_QUERY = '(max-width: 767px)';

function buildSlides(grid) {
  const cards = Array.from(grid.querySelectorAll('.insights__card'));
  if (!cards.length) {
    return null;
  }

  const wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  cards.forEach((card) => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(card);
    wrapper.appendChild(slide);
  });

  grid.replaceChildren(wrapper);
  grid.classList.add('swiper', 'insights__grid--swiper');
  return cards;
}

function teardown(grid) {
  const cards = Array.from(grid.querySelectorAll('.insights__card'));
  grid.classList.remove('swiper', 'insights__grid--swiper');
  grid.replaceChildren(...cards);
}

export function initInsightsRelated() {
  const grids = document.querySelectorAll('.js-insightsRelated');
  if (!grids.length) {
    return;
  }

  const query = window.matchMedia(MOBILE_QUERY);

  grids.forEach((grid) => {
    let instance = null;

    const enable = () => {
      if (instance || !buildSlides(grid)) {
        return;
      }

      instance = new Swiper(grid, {
        modules: [A11y, Keyboard],
        slidesPerView: 1.1,   // eine Kachel + Peek auf die naechste
        spaceBetween: 14,     // identisch zum --insights-gap des Rasters
        grabCursor: true,
        watchOverflow: true,  // eine einzelne Kachel bleibt statisch
        keyboard: { enabled: true },
        a11y: { enabled: true },
      });
    };

    const disable = () => {
      if (!instance) {
        return;
      }
      instance.destroy(true, true);
      instance = null;
      teardown(grid);
    };

    const sync = (matches) => (matches ? enable() : disable());

    sync(query.matches);
    query.addEventListener('change', (event) => sync(event.matches));
  });
}
